import { Actions } from "services/AccessControl";
import { isAllowed } from "lib/permToolkit";

export default (subject, action, ressource) => {

    switch (action) {
        case Actions.Create:
            return isAllowed(subject, "GestionCandidats", ressource) || isAllowed(subject, "ValiderCandidats", ressource);
        case Actions.Read:
            return isAllowed(subject, "GestionCandidats", ressource) || isAllowed(subject, "ValiderCandidats", ressource);
        case Actions.Update:
            return isAllowed(subject, "GestionCandidats", ressource) || isAllowed(subject, "ValiderCandidats", ressource);
        case Actions.Valid:
            return isAllowed(subject, "ValiderCandidats", ressource);
        default: 
            return false;
    };
}